module.exports = __webpack_public_path__ + "img/app-yixue.13928116.png";